"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_FEEDBACK_RATINGS = void 0;
exports.USER_FEEDBACK_RATINGS = {
    GOOD: 'good',
    NEUTRAL: 'neutral',
    BAD: 'bad',
};
//# sourceMappingURL=user-feedback.types.js.map